import { render } from "./EditShopSubProduct.vue?vue&type=template&id=2308d8c0"
import script from "./EditShopSubProduct.vue?vue&type=script&lang=js"
export * from "./EditShopSubProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__